import { lightBaseColors, lightBrandColors, lightDangerColors, lightNeutralColors, lightPositiveColors, lightWarningColors, darkBaseColors, darkBrandColors, darkDangerColors, darkNeutralColors, darkPositiveColors, darkWarningColors, } from './semanticColors';
import { darkExtendedColors, lightExtendedColors, } from './semanticColors/extendedColors';
// TODO: shall be deprecated when we fully migrate to the new colors in all MFEs
const rawColors = {
    blue: '#3D6BFF',
    darkBlue: '#18003F',
    midBlue: '#171572',
    veryLightBlue: '#E0EAFF',
    lightBlue: '#C4D6FC',
    primary: '#3D6BFF',
    secondary: '#4ec3f7',
    tertiary: '#3D6BFF',
    highlightBlue: '#dae8fd',
    greys: ['#8e8e93', '#bfbfbf', '#d1d1d6', '#e5e5ea', '#f4f4f4', '#f2f2f2'],
    greens: ['#b7eddf', '#028953', '#D8F6C9'],
    red: '#b60e36',
    success: '#43a047',
    info: '#3D6BFF',
    warning: '#ffa000',
    danger: '#B83C36',
    lavender: '##D2DFFC',
    babyBlue: '#D6EFFC',
    teal: '#CCF4EA',
    yellow: '#FCEBBC',
    peach: '#F0CAC3',
    pink: '#FADEE5',
    purple: '#EBE3FC',
};
const blues = {
    chocoDarkBlue: '#18003F',
    chocoMidBlue: '#1A0D78',
    chocoBlue: '#3D6BFF',
    chocoLightBlue: '#C0D5FF',
    chocoVeryLightBlue: '#E0EAFF',
};
const neutrals = {
    black: '#000000',
    chocoGreys: [
        '#333333',
        '#666666',
        '#999999',
        '#CCCCCC',
        '#E6E6E6',
        '#F2F2F2',
        '#F7F7F7',
    ],
    white: '#ffffff',
    cream: '#FAF7F5',
    iceCream: '#EAE6E3',
    creamDarker: '#EEE4DE',
    transparent: 'rgba(255, 255, 255, 0)',
    gray800: '#262626',
    gray700: '#333333',
    gray600: '#666666',
    gray500: '#999999',
    gray400: '#CCCCCC',
    gray300: '#E6E6E6',
    gray200: '#F2F2F2',
    gray100: '#F7F7F7',
};
const extended = {
    squash: '#E55500',
    orange: '#FF8900',
    coconut: '#FFEFBD',
    pomegranate: '#890A00',
    gojiBerry: '#AC2819',
    lychee: '#FFE8DF',
    spinach: '#034B46',
    cucumber: '#006854',
    mint: '#D1EDD8',
};
const functionals = {
    plum: '#FF5A46',
    banana: '#FFDC48',
    honeyDew: '#34C380',
    plumText: '#D82C17',
    bananaText: '#DEB400',
    honeyDewText: '#0C7845',
};
const transparent = {
    black50: 'rgba(0, 0, 0, 0.5)',
    black70: 'rgba(0, 0, 0, 0.7)',
    white50: 'rgba(255, 255, 255, 0.5)',
};
export const lightModeColors = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, lightBaseColors), lightNeutralColors), lightPositiveColors), lightWarningColors), lightDangerColors), lightBrandColors), lightExtendedColors);
const darkModeColors = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, darkBaseColors), darkNeutralColors), darkPositiveColors), darkWarningColors), darkDangerColors), darkBrandColors), darkExtendedColors);
export const colors = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, rawColors), blues), neutrals), functionals), extended), transparent), lightModeColors), { text: lightNeutralColors.neutralText, modes: {
        dark: Object.assign({ text: darkNeutralColors.neutralText }, darkModeColors),
    } });
//# sourceMappingURL=data:application/json;base64,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